import AbstractRosterShift from './AbstractRosterShift';

export default class RosterShift extends AbstractRosterShift {
  constructor(start, end, hasActuals) {
    super('shift', start, end, hasActuals);
  }

  createNew(start, end, hasActuals) {
    return new RosterShift(start, end, hasActuals);
  }
}
